import { useAuthStore } from '../store';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { HeadphonesIcon, MessageCircle, Send, Bug, User } from 'lucide-react';

export default function SupportPage() {
  const { user } = useAuthStore();

  const uplineWhatsapp = (user?.upline_whatsapp || '').replace(/\D/g, '');

  return (
    <div className="space-y-6" data-testid="support-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-heading font-bold text-foreground flex items-center gap-3">
          <HeadphonesIcon className="w-8 h-8 text-primary" />
          Suporte
        </h1>
        <p className="text-muted-foreground mt-1">
          Precisa de ajuda? Fale diretamente com a gente pelos canais abaixo.
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 max-w-4xl">
        {uplineWhatsapp && (
          <Card data-testid="support-whatsapp-card" className="border-emerald-500/30 hover:border-emerald-500/60 transition-colors">
            <CardContent className="pt-6 flex flex-col items-start gap-4">
              <div className="w-12 h-12 rounded-full bg-emerald-500/15 flex items-center justify-center">
                <User className="w-6 h-6 text-emerald-500" />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-lg text-foreground">Suporte do seu Revendedor</h3>
                <p className="text-sm text-muted-foreground mt-1">
                  Dúvidas sobre seu plano, renovação, créditos ou uso do painel? Fale com quem cuida da sua conta.
                </p>
              </div>
              <Button
                asChild
                data-testid="support-whatsapp-btn"
                className="bg-emerald-500 hover:bg-emerald-600 text-white w-full"
              >
                <a href={`https://wa.me/${uplineWhatsapp}`} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-4 h-4 mr-2" />
                  Chamar no WhatsApp
                </a>
              </Button>
            </CardContent>
          </Card>
        )}

        <Card data-testid="support-telegram-card" className="border-sky-500/30 hover:border-sky-500/60 transition-colors">
          <CardContent className="pt-6 flex flex-col items-start gap-4">
            <div className="w-12 h-12 rounded-full bg-sky-500/15 flex items-center justify-center">
              <Bug className="w-6 h-6 text-sky-500" />
            </div>
            <div>
              <h3 className="font-heading font-semibold text-lg text-foreground">Bugs e problemas do sistema</h3>
              <p className="text-sm text-muted-foreground mt-1">
                Encontrou um erro, falha ou comportamento estranho na plataforma? Reporte no nosso Telegram oficial.
              </p>
            </div>
            <Button
              asChild
              data-testid="support-telegram-btn"
              className="bg-sky-500 hover:bg-sky-600 text-white w-full"
            >
              <a href="https://t.me/nexuzap_suporte" target="_blank" rel="noopener noreferrer">
                <Send className="w-4 h-4 mr-2" />
                @nexuzap_suporte
              </a>
            </Button>
          </CardContent>
        </Card>
      </div>

      {!uplineWhatsapp && (
        <p className="text-sm text-muted-foreground max-w-4xl" data-testid="support-no-upline-note">
          Utilize o Telegram oficial acima para qualquer dúvida ou problema.
        </p>
      )}
    </div>
  );
}
